import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './index.module.sass';
import { $recipeMixData, $selectedMix } from '@/modules/mixing/store/recipes.store';
import { useStore } from 'effector-react';
import { toReadable } from '@/modules/mixing/helpers/to-readable.helper';
import { IMixRoot } from '@/modules/mixing/ts';

export const TopInfo = () => {
  //const selectedMix = useStore($selectedMix);
  const recipeMixData = useStore($recipeMixData);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.topLine}>
          <span className={styles.heading}>результат миксования</span>
          <div className={styles.weightInfo}>
            <span className={styles.label}>вес</span>
            <span className={styles.value}>{toReadable(recipeMixData ? recipeMixData.mix.weight_a + recipeMixData.mix.weight_b : 0 )} т</span>
          </div>
        </div>
        <div className={styles.bottomLine}>
          <CardRequisite
            label="клейковина"
            value={
              recipeMixData?.mix?.mixed_properties.find((item) => item.name === 'Клейковина')
                ?.value
            }
            sign="%"
          />
          <CardRequisite
            label="влажность"
            value={
              recipeMixData?.mix?.mixed_properties.find(
                (item) => item.name === 'Влажность культуры',
              )?.value
            }
            sign="%"
          />
          <CardRequisite
            label="ИДК"
            value={
              recipeMixData?.mix?.mixed_properties.find((item) => item.name === 'ИДК')?.value
            }
          />
          <CardRequisite
            label="число падения"
            value={
              recipeMixData?.mix?.mixed_properties.find(
                (item) => item.name === 'Число падения',
              )?.value
            }
            sign="сек"
          />
          <CardRequisite
            label="протеин"
            value={
              recipeMixData?.mix?.mixed_properties.find((item) => item.name === 'Протеин')
                ?.value
            }
            sign="кДа"
          />
          <CardRequisite
            label="натура"
            value={
              recipeMixData?.mix?.mixed_properties.find((item) => item.name === 'Натура')
                ?.value
            }
            sign="г/л"
          />
          <CardRequisite
            label="итог"
            value={recipeMixData ? recipeMixData?.mix?.price_per_ton * (recipeMixData.mix.weight_a + recipeMixData.mix.weight_b) : 0}
            sign="₽"
            className={styles.last}
          />
        </div>
      </div>
      <div className={styles.profitArea}>
        <span className={styles.profitlabel}>выгода от микса</span>
        <span className={styles.profitValue}>
          {recipeMixData?.mix.price_delta && recipeMixData?.mix.price_delta > 0
            ? `+ ${toReadable(recipeMixData?.mix.price_delta)} ₽`
            : `0 ₽`}
        </span>
        <div className={styles.filler}></div>
      </div>
    </div>
  );
};

export const CardRequisite = ({
  value,
  label,
  sign,
  className,
}: {
  value: ReactNode;
  label: ReactNode;
  sign?: ReactNode;
  className?: string;
}) => {
  return (
    <div className={classNames(styles.cardRequisite, className)}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {sign === '₽'
          ? toReadable(Number(value))
          : typeof value === 'string'
          ? Number(value).toFixed(2)
          : value}{' '}
        <span className={styles.sign}>{sign}</span>
      </span>
    </div>
  );
};
